import * as React from 'react';
import { RadioGroup, IRadioGroupProps, Label, keyType, StackPanelOrientation } from '@agilepoint/wat-react-ux';
import { Controller, UseControllerReturn, useFormContext } from 'react-hook-form';
import { IBaseFormFieldProps, FieldBlock } from '@agilepoint/wat-react-ux-form-fields';
import { memoizeFunction } from '@agilepoint/utils-common';

interface IRadioGroupFormFieldProps extends IBaseFormFieldProps, Omit<IRadioGroupProps, 'name'> {
    fieldOrientation?: StackPanelOrientation
}

const createOnChangeProxy = memoizeFunction((onChange: any, onValueChange: any) =>
    (selectedKey: keyType) => {
        if (onValueChange !== undefined) {
            onValueChange(selectedKey);
        }
        return onChange(selectedKey);
    }
);
export function RadioGroupField(props: IRadioGroupFormFieldProps) {
    const { className, name, validationRules, label, defaultSelectedKey, gap, fieldOrientation, onValueChange, title, ...restProps } = props;
    const { control } = useFormContext();

    const renderRadioGroup = React.useCallback(({ field: { onChange, value } }: UseControllerReturn) => (
        <RadioGroup {...restProps} onValueChange={(createOnChangeProxy(onChange, onValueChange))} selectedKey={value} />
    ), [onValueChange, restProps]);

    return (
        <FieldBlock gap={gap} orientation={fieldOrientation} className={className} title={title}>
            {label ? <Label required={validationRules && !!validationRules.required}>{label}</Label> : <></>}
            <Controller control={control} name={name} render={renderRadioGroup}
                defaultValue={defaultSelectedKey} rules={validationRules} />
        </FieldBlock>
    );
}
